<template>
    <div class="preview-broadcast-container">
        <p class="preview-header"><i class="bx bx-movie-play"></i> Preview Broadcast</p>
        <div class="preview-line-broadcast">
            <!-- Phone layout -->
            <div v-if="!Array.isArray(previewMessageList) || previewMessageList.length <= 0" class="preview-content--default">
                <img src="@/assets/images/preview_content.png" alt="preview icon">
                <p class="preview-title">Preview</p>
                <p class="preview-description">Add content on the left panel<br/>and click 'Preview' to get started.</p>
            </div>
            <div v-else class="preview-content--messages">
                <div class="scrollable-message">
                    <div v-for="(message, index) in previewMessageList" :key="index">
                        <div v-if="message.type === 'TEXT'">
                            <TextMessagePreview :text="message.text"/>
                        </div>
                        <div v-else-if="message.type === 'IMAGE'">
                            <ImageMessagePreview :imageUrl="message.originalContentUrl" />
                        </div>
                        <div v-else-if="message.type === 'VIDEO'">
                            <VideoMessagePreview :thumbnailUrl="message.previewImageUrl" />
                        </div>
                        <div v-else-if="message.type === 'IMAGEMAP'">
                            <ImageMapMessagePreview :baseUrl="message.baseUrl" />
                        </div>
                        <div v-else>
                            <p>This {{ message.type }} message type will support in the feature task.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextMessagePreview from './PreviewMessageTemplate/TextMessagePreview.vue';
import ImageMessagePreview from './PreviewMessageTemplate/ImageMessagePreview.vue';
import VideoMessagePreview from './PreviewMessageTemplate/VideoMessagePreview.vue';
import ImageMapMessagePreview from './PreviewMessageTemplate/ImageMapMessagePreview.vue';

export default {
  name: 'PreviewBroadcast',
  components: {
    TextMessagePreview,
    ImageMessagePreview,
    VideoMessagePreview,
    ImageMapMessagePreview
  },
  props: {
    previewMessageList: {
      type: Array,
      required: false,
    }
  },
};
</script>

<style lang="scss" scoped>
.preview-broadcast-container{
    padding: 0px 16px;
    width: 360px;
    p{
        margin: 0;
    }
    .preview-header{
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0px;
        color: #111B49;
        text-align: center;
    }
    .preview-line-broadcast {
        position: relative;
        width: 360px;
        height: 615px;
        background: url('~@/assets/images/phone_template.png') no-repeat center center;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0;
        max-width: 100%;
    }
    .preview-content {
        &--default {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border-radius: 40px;
            width: 91%;
            height: 92%;
            overflow: hidden;
            .preview-title{
                font-weight: 500;
                font-size: 16px;
                line-height: 120%;
                letter-spacing: 0px;
                text-align: center;
                padding: 12px;
                color: #4B5178;
            }
            .preview-description{
                font-weight: 400;
                font-size: 13px;
                line-height: 150%;
                letter-spacing: 0%;
                text-align: center;
                color: #646A8C;
            }
        }
        &--messages {
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: start;
            background-color: #fff;
            border-radius: 40px;
            width: 91%;
            height: 92%;
            padding: 14px;
            .scrollable-message{
                overflow-y: auto;
                padding-right: 6px;
                width: 275px;
            }
        }
    }
}
</style>
